import { ImageExtension } from "@/types/image"

export const acceptedImageExtensions: ImageExtension[] = [
  {
    extension: "JPG",
    MIMEType: "image/jpeg",
  },
  {
    extension: "PNG",
    MIMEType: "image/png",
  },
]
